<div class="ui-g-12">
    <app-loading *ngIf="this.consultation.other_data.supportConsult.verifyApiResult.Posting"
        type="SMALL_LOADER"></app-loading>
    <ng-container
        *ngIf="!this.consultation.other_data.supportConsult.verifyApiResult.Posting && this.consultation.other_data.supportConsult.otherData.is_verified; else notVerified">
        <form accept-charset="UTF-8" #consultDoctorForm="ngForm" (submit)="submitConsultation()">
            <div class="ui-g">
                <div class="ui-g-12">
                    <p-fieldset [style]="{'border':'1px solid #000000'}"
                        *ngIf="!this.consultation.other_data.user_packages_list_api_result.Posting">
                        <p-header><b>Select Consultation Type</b></p-header>
                        <div class="ui-g">
                            <div class="ui-lg-4 ui-md-6 ui-g-12" *ngIf="!this.is_uk_country">
                                <p-radioButton name="consultation_type_id"
                                    [value]="this.consultation.const_data.CONSULTATION_TYPES.PRIMARY_MEDICAL_CONSULTATION"
                                    label="Primary Medical Consultation"
                                    [(ngModel)]="this.consultation.consultApiData.consultation_type_id"
                                    (ngModelChange)="onConsultationChange()" #consultation_type="ngModel"
                                    (click)="notDirty()"
                                    [disabled]="isPosting() || this.consultation.other_data.packageConsultDoctor.otherData.consultationDisabled"
                                    required>
                                </p-radioButton>
                            </div>
                            <div class="ui-lg-4 ui-md-6 ui-g-12">
                                <p-radioButton name="consultation_type_id"
                                    [value]="this.consultation.const_data.CONSULTATION_TYPES.EXPERT_SECOND_MEDICAL_CONSULTATION"
                                    [label]="this.is_uk_country?'Specialist Consultation':'Expert Second Medical Opinion'"
                                    [(ngModel)]="this.consultation.consultApiData.consultation_type_id"
                                    (ngModelChange)="onConsultationChange()" #consultation_type="ngModel"
                                    (click)="notDirty()"
                                    [disabled]="isPosting() || this.consultation.other_data.packageConsultDoctor.otherData.consultationDisabled"
                                    required>
                                </p-radioButton>
                            </div>
                        </div>

                    </p-fieldset>

                    <ng-container *ngIf="isConsultationSelected()">
                        <p-fieldset *ngIf="!this.consultation.other_data.user_packages_list_api_result.Posting && 
                                this.consultation.other_data.user_packages_list_api_result.PromiseResult.success"
                            [style]="{'border':'1px solid #000000'}">
                            <p-header><b>Payment Options</b></p-header>
                            <div class="ui-g">
                                <div class="ui-g-12"
                                    *ngIf="this.consultation.other_data.packages_status_data.length!=0">
                                    <p-radioButton name="payment_option" [value]="false" label="Use my Package"
                                        [(ngModel)]="this.consultation.other_data.is_pay" #payment_option="ngModel"
                                        (ngModelChange)="onPaymentChange()" required
                                        [disabled]="isPosting() ||  this.consultation.other_data.packageConsultDoctor.otherData.packagesDiabled">
                                    </p-radioButton>
                                    <p>
                                        (By selecting the package 1 consultation will be used from selected
                                        package)
                                    </p>
                                    <ng-container *ngIf="!isPay()">
                                        <div class="ui-g pl-5rem"
                                            *ngFor="let package of this.consultation.other_data.packages_status_data">
                                            <div class="ui-g-12">
                                                <p-radioButton name="package_option" [value]="package.id"
                                                    [label]="package.final_name"
                                                    [(ngModel)]="this.consultation.consultApiData.user_package_id"
                                                    #package_option="ngModel"
                                                    [disabled]="isPosting() ||  this.consultation.other_data.packageConsultDoctor.otherData.packagesDiabled"
                                                    [required]="!this.consultation.other_data.is_pay">
                                                </p-radioButton>
                                                <p class="alert-success">({{text(package.user_package_count)}})
                                                </p>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>

                                <div class="ui-g-12">
                                    <p-radioButton name="payment_option" [value]="true" label="Pay for consultation"
                                        [(ngModel)]="this.consultation.other_data.is_pay" #payment_option="ngModel"
                                        (ngModelChange)="onPaymentChange()" required
                                        [disabled]="isPosting() || this.consultation.other_data.packageConsultDoctor.otherData.packagesDiabled">
                                    </p-radioButton>
                                </div>
                            </div>
                        </p-fieldset>
                        <p-fieldset [style]="{'border':'1px solid #000000'}">
                            <p-header><b>Consultation Form</b></p-header>
                            <div class="ui-g">
                                <div class="ui-g-12">
                                    <div class="ui-g">
                                        <div class="ui-g-12 ui-md-12">
                                            <p class="m-3 heading3" style="color:#004aad"><b>Book an appointment</b></p>
                                            <div class="form-group row">

                                                <div class="ui-md-5 ui-g-12 ml-4">
                                                    <!-- <div class="ui-g-12">
                                                        <label class="ui-g-12 font-weight-bold" for="vendor">Vendor
                                                            Name*</label>
                                                        <p-dropdown id="dropdown" [options]="this.vendorsList"
                                                            styleClass="input-pill input-dropdown-pill mb-3 pl-3"
                                                            placeholder="Select vendor" aria-disabled="true">
                                                        </p-dropdown>
                                                        <p class="margin-left">
                                                            <span
                                                                style="border:1px solid #aeb0b5;padding:7px;color:#212121;">
                                                                {{this.consultation.other_data.supportConsult.otherData.vendor_name}}</span>
                                                        </p>
                                                    </div> -->
                                                    <div class="ui-g-12">
                                                        <label class="ui-g-12 font-weight-bold"
                                                            for="patient_name">Patient
                                                            Name*</label>
                                                        <p class="margin-left">
                                                            <span
                                                                style="border:1px solid #aeb0b5;padding:7px;color:#212121;">
                                                                {{this.consultation.other_data.supportConsult.otherData.patient_name}}</span>
                                                        </p>
                                                    </div>
                                                    <ng-container
                                                        *ngIf="this.consultation.other_data.slotsFetch.other_data.is_display">
                                                        <div class="ui-g-12">
                                                            <app-time-slots
                                                                [(timeSlotsData)]="this.consultation.other_data.slotsFetch.timeSlots"
                                                                (date_selected)="onSlotsDateChanged($event)"
                                                                (slot_id_selected)="onSlotSelected($event)"></app-time-slots>
                                                        </div>
                                                    </ng-container>
                                                </div>

                                                <div class="ui-md-5 ui-g-12">
                                                    <div>
                                                        <label class="ui-g-12 font-weight-bold"
                                                            for="specialty">Specialty*</label>

                                                        <p-dropdown id="choose_specialty"
                                                            [options]="this.consultation.other_data.specialty_data"
                                                            name="speciality" [filter]="true" [filterBy]='"label"'
                                                            [(ngModel)]="this.consultation.other_data.selectedSpecialtyId"
                                                            (ngModelChange)="onSpecialityChange()" placeholder="Select"
                                                            #speciality="ngModel" (onChange)="dirty()"
                                                            [required]="true">
                                                        </p-dropdown>
                                                        <div *ngIf="speciality.invalid && (speciality.dirty || speciality.touched)"
                                                            class="alert alert-danger">
                                                            <div *ngIf="speciality.errors.required"
                                                                class="alert alert-danger">
                                                                Specialty is required.
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label class="ui-g-12 font-weight-bold"
                                                            for="comments">Comments*</label>
                                                        <!-- <textarea id="Comments"
                                                    class="WordWrap format-lines textarea-doctor-registration"
                                                    placeholder="Type Here" name="Comments">
                                                </textarea> -->
                                                        <textarea [pKeyFilter]="this.consultation.regExp.textarea"
                                                            [(ngModel)]="this.consultation.consultApiData.condition_description"
                                                            name="condition_description"
                                                            class="WordWrap format-lines textarea-input height-100px"
                                                            placeholder="Enter your conditions here"
                                                            [maxlength]="this.consultation.const_data.CONDITION_DESCRIPTION"
                                                            pInputTextarea #details="ngModel" name="details"
                                                            required></textarea>
                                                        <div *ngIf="details.invalid && (details.dirty || details.touched)"
                                                            class="alert alert-danger">
                                                            <div *ngIf="details.errors.required"
                                                                class="alert alert-danger">
                                                                Medical condition is required.
                                                            </div>
                                                        </div>
                                                        <div class="ui-g-12">
                                                            <p
                                                                [style.color]="this.consultation.consultApiData.condition_description.length-(this.consultation.const_data.CONDITION_DESCRIPTION-1)>0?'red':'green'">
                                                                {{((this.consultation.const_data.CONDITION_DESCRIPTION+1)-this.consultation.consultApiData.condition_description.length)
                                                                <0?0:this.consultation.const_data.CONDITION_DESCRIPTION-this.consultation.consultApiData.condition_description.length}}
                                                                    of
                                                                    {{this.consultation.const_data.CONDITION_DESCRIPTION}}
                                                                    left </p>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="ui-md-5 ui-g-12" *ngIf="!isPackageSpecialty();">
                                                    <div>
                                                        <ng-container
                                                            *ngIf="!this.consultation.other_data.user_packages_list_api_result.Posting || this.consultation.other_data.priority_list_api_result.Posting ">
                                                            <ng-container
                                                                *ngIf="this.consultation.other_data.priority_list?.length>0">
                                                                <div class="ui-g-12">
                                                                    <div class="ui-g-12">
                                                                        <label for="doctor_origin">
                                                                            Doctor Region<span class="req">*</span>:
                                                                        </label>
                                                                    </div>

                                                                    <div class="ui-g-12">
                                                                        <div class="ui-g-12"
                                                                            *ngFor="let priority of this.consultation.other_data.priority_list">
                                                                            <p-radioButton
                                                                                name="consultation_priority_type_id"
                                                                                id="consultation_priority_type_id"
                                                                                [value]="priority.id"
                                                                                [label]="isPay()?priority.price_label:priority.no_price_label"
                                                                                [(ngModel)]="this.consultation.consultApiData.priority_type_id"
                                                                                #consultation_priority_type_id="ngModel"
                                                                                (click)="dirty()"
                                                                                [disabled]="isPosting()"
                                                                                required>
                                                                            </p-radioButton>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ui-g text-center">
                                <div class="ui-g-12">
                                    <p-button type="submit" [style]="{'margin-right':'5px'}"
                                        [disabled]="!this.consultDoctorForm.valid || isPosting()" label=" Submit"
                                        class="p-button-lg submit-btn">
                                    </p-button>

                                    <p style="color:red"
                                        *ngIf="this.consultation.other_data.submit_consultation_api_result.PromiseResult.success!=null && this.consultation.other_data.submit_consultation_api_result.PromiseResult.success==false">
                                        {{this.consultation.other_data.submit_consultation_api_result.ServerError.message}}
                                    </p>
                                    <p class="heading4" style="color:green"
                                        *ngIf="this.consultation.other_data.submit_consultation_api_result.PromiseResult.success!=null && this.consultation.other_data.submit_consultation_api_result.PromiseResult.success==true">
                                        Consultation Booked
                                    </p>
                                </div>
                            </div>
                            <div class="ui-g-12 text-center">
                                <app-error-messages [api_result]="this.consultation.other_data.submit_consultation_api_result"></app-error-messages>
                            </div>
                        </p-fieldset>
                    </ng-container>
                </div>
            </div>

        </form>

    </ng-container>
    
    <ng-template #notVerified>
        <app-error-messages [api_result]="this.consultation.other_data.supportConsult.verifyApiResult">
        </app-error-messages>
    </ng-template>
    
</div>